import { render, staticRenderFns } from "./JoinSessionAlertPopup.vue?vue&type=template&id=ebe6c97c"
import script from "./JoinSessionAlertPopup.vue?vue&type=script&lang=js"
export * from "./JoinSessionAlertPopup.vue?vue&type=script&lang=js"
import style0 from "./JoinSessionAlertPopup.vue?vue&type=style&index=0&id=ebe6c97c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports